import { render, staticRenderFns } from "./appRight.vue?vue&type=template&id=96651c36&"
import script from "./appRight.vue?vue&type=script&lang=js&"
export * from "./appRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports